<template>
    <div class="home container" v-if="organisation">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>Dashboard</el-breadcrumb-item>
        </el-breadcrumb>

        <h1 class="container__title h1">{{ organisation.name }} Trees</h1>

        <div class="container__section container__section--space-small">
            <router-link :to="{ name: 'New Tree' }">
                <Button :showIcon="true"
                    >Add new tree
                    <IconPlus slot="icon" />
                </Button>
            </router-link>
        </div>

        <div class="container__section">
            <div class="home__trees" v-if="trees.length > 0">
                <router-link
                    class="home__tree"
                    v-for="tree in trees"
                    :key="tree.slug"
                    :to="{ name: 'Links', params: { treeslug: tree.slug } }"
                >
                    <div class="home__tree__avatar">
                        <img
                            :src="tree.image.data.thumbnails.large"
                            alt=""
                            v-if="tree.image"
                        />
                    </div>
                    <div class="home__tree__content">
                        <h2
                            class="home__tree__title h3"
                            v-html="tree.name"
                        ></h2>
                        <div class="home__tree__slug">/{{ tree.slug }}</div>
                    </div>
                </router-link>
            </div>
            <div class="home__notfound grey" v-else>
                No linktrees found.
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from '@/components/Button.vue';
import IconPlus from '@/components/icons/IconPlus.vue';

export default {
    name: 'Home',
    components: {
        Button,
        IconPlus,
    },
    computed: {
        ...mapGetters(['trees', 'organisation']),
    },
    mounted() {
        console.log(this.organisation);
    },
};
</script>

<style lang="scss">
.home {
    &__tree {
        display: flex;
        align-items: center;
        background: $barely-white;
        padding: 20px;
        margin-bottom: 15px;
        transition: $link-transition;

        .no-touch &:hover {
            background: $almost-black;
            color: white;
        }

        &__avatar {
            position: relative;
            width: 100px;
            height: 100px;
            border-radius: 100%;
            overflow: hidden;
            margin-right: 30px;
            background: white;

            img {
                @include object-fit;
            }
        }

        &__content {
            padding: 10px 0;
        }
    }

    &__notfound {
        margin-bottom: 16px;
    }
}
</style>
